(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nl-pdp-extras"] && !Shopify.designMode) return;
  try {
    // "Leuk erbij" (one row) and "Maak de look compleet" (all ticked rows): add to the cart, then
  // refresh the cart drawer/count like the theme does
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-nl-pair], [data-nl-pair-all]');
    if (!btn || btn.disabled) return;
    const rows = btn.matches('[data-nl-pair]')
      ? [btn.closest('[data-nl-pair-row]')]
      : [...btn.closest('[data-nl-pair-box]').querySelectorAll('[data-nl-pair-row]')].filter((row) => row.querySelector('.nl-pair__check')?.checked);
    const items = rows.map((row) => ({ id: Number(row.querySelector('[data-nl-pair-variant]').value), quantity: 1 }));
    if (!items.length) return;
    const label = btn.textContent;
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!res.ok) throw new Error();
      btn.textContent = 'Toegevoegd ✓';
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: await (await fetch('/cart.js')).json(), sourceId: 'nl-pair', data: { source: 'nl-pair' } } }));
      setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 2500);
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Probeer opnieuw';
    }
  });

  // size advisor: EU size she normally wears -> this product's size, read from the option names
  // ("S (36)", "M (EU 38)") or else from the EU column of the size table in the description
  const NL_LETTERS = { XS: [34], S: [36], M: [38], L: [40], XL: [42], XXL: [44], '2XL': [44], '3XL': [46], XXXL: [46] };
  const nlEuNums = (text) => {
    const nums = (text.match(/\d{2}/g) || []).map(Number).filter((n) => n >= 30 && n <= 56);
    if (nums.length === 2 && /\d{2}\s*[-–/]\s*\d{2}/.test(text)) {
      const range = [];
      for (let n = nums[0]; n <= nums[1]; n++) range.push(n);
      return range;
    }
    return nums;
  };
  const nlSizeMap = (scope) => {
    const fieldset = [...scope.querySelectorAll('fieldset.variant-option')].find((f) => f.querySelector('legend')?.textContent.trim().startsWith('Maat'));
    if (!fieldset) return [];
    const table = scope.querySelector('.rte table, table');
    let euCol = -1;
    let rows = [];
    if (table) {
      euCol = [...table.querySelectorAll('th')].findIndex((th) => /EU/i.test(th.textContent));
      rows = [...table.querySelectorAll('tbody tr')].map((tr) => [...tr.cells].map((td) => td.textContent.trim()));
    }
    const sizes = [...fieldset.querySelectorAll('input[type="radio"]')].map((input) => {
      const label = input.value.replace(/\s*\(.*\)\s*/, '').trim();
      const paren = input.value.match(/\(([^)]*)\)/);
      let eu = paren ? nlEuNums(paren[1]) : [];
      if (!eu.length && euCol > -1) {
        const row = rows.find((r) => r[0] === label || r[0] === input.value);
        if (row && row[euCol]) eu = nlEuNums(row[euCol]);
      }
      return { input, label, eu };
    });
    if (sizes.every((s) => !s.eu.length)) sizes.forEach((s) => { s.eu = NL_LETTERS[s.label.toUpperCase()] || []; });
    return sizes.filter((s) => s.eu.length).sort((a, b) => Math.min(...a.eu) - Math.min(...b.eu));
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-nl-fit-eu]');
    if (!btn) return;
    const box = btn.closest('[data-nl-fit]');
    const scope = box.closest('.product-details') || document;
    const result = box.querySelector('[data-nl-fit-result]');
    const hasTable = !!scope.querySelector('.rte table, table');
    const tableLink = hasTable ? ' Twijfel je? Lees ook het advies onder de <a href="#" data-nl-size>maattabel</a>.' : '';
    box.querySelectorAll('[data-nl-fit-eu]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    const n = Number(btn.dataset.nlFitEu);
    const sizes = nlSizeMap(scope);
    if (!sizes.length) {
      result.innerHTML = hasTable ? 'Vergelijk je maten in cm met de <a href="#" data-nl-size>maattabel</a>.' : 'Voor dit model hebben we geen maattabel.';
      return;
    }
    const all = sizes.flatMap((s) => s.eu);
    let pick = sizes.find((s) => s.eu.includes(n));
    let msg = '';
    if (!pick && n > Math.max(...all)) {
      const last = sizes[sizes.length - 1];
      result.innerHTML = `Maat ${n} hebben we bij dit model helaas niet. De grootste maat is ${last.label} (EU ${Math.max(...last.eu)}).${tableLink}`;
      return;
    }
    if (!pick && n < Math.min(...all)) {
      pick = sizes[0];
      msg = `Dit model begint bij maat <strong>${pick.label}</strong> (EU ${Math.min(...pick.eu)}). Neem die maat.`;
    } else {
      pick = pick || sizes.find((s) => Math.min(...s.eu) > n);
      msg = `Voor jou raden we maat <strong>${pick.label}</strong> aan${pick.label.toUpperCase() !== btn.firstChild.textContent.trim() ? ', want dit model valt anders dan je gewend bent' : ''}.`;
    }
    if (pick.input.closest('label')?.querySelector('.nl-soldout')) {
      msg += ' Die maat is op dit moment helaas uitverkocht.';
    } else {
      if (!pick.input.checked) pick.input.click();
      msg += ' We hebben hem voor je geselecteerd.';
    }
    result.innerHTML = msg + tableLink;
  });

  // "Maattabel" next to Maat scrolls to the size table in the description
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-nl-size]');
    if (!link) return;
    e.preventDefault();
    const table = link.closest('.product-details')?.querySelector('.rte table, table');
    table?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  } catch(e) { console.error(e); }
})();

})();
